<template>
  <div>
    <Attention/>
    <Apologize/>
    <div :class="{'is-drawr-opend': isSP && selectedPlace, 'is-wv': isWV}">
      <Header v-if="!isWV"/>
      <main>
        <Content/>
        <NoticeLine v-if="false"/>
        <HelpLine v-if="false"/>
        <Description/>
        <News v-if="!isWV"/>
      </main>
      <Footer/>
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters, mapState } from 'vuex'
import Attention from '@/components/Attention.vue'
import Apologize from "@/components/Apologize.vue"
import Header from "@/components/Header.vue"
import Content from '@/components/Home/Content.vue'
import NoticeLine from '@/components/Home/NoticeLine.vue'
import HelpLine from '@/components/Home/HelpLine.vue'
import Description from '@/components/Home/Description.vue'
import News from '@/components/Home/News.vue'
import Footer from "@/components/Footer.vue"
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Home',
  components: {
    Attention,
    Apologize,
    Header,
    Content,
    NoticeLine,
    HelpLine,
    Description,
    News,
    Footer,
  },
  computed: {
    ...mapGetters(['isSP', 'isWV']),
    ...mapState(['selectedPlace']),
  },
})
</script>

<style scoped lang="scss">
.is-drawr-opend {
  /*
   * 下からドロワー出てきた時のスクロール可能範囲の調整
   * これしないと、裏が見えてしまう。
   */
  height: calc(51vh + 50px + 531px - 50px);
  overflow: hidden;

  &.is-wv {
    /* WebView用レイアウトの場合、ヘッダ非表示分を除く */
    height: calc(51vh + 531px - 50px);
  }
}
</style>
